import { DEFAULT_SHARED_PARAMETERS } from '../../constants/defaultSharedParameters';
import { useSharedParameterStore } from '../../stores/useSharedParameterStore';

export interface ParameterAdditionPayload {
  parameterNames: string[];
  categories?: string[];
  sharedParameterFilePath?: string;
  sharedParameterFileContent?: string;
  bindingKind?: 'type' | 'instance';
  targetObjectTypes?: string[];
  objectTypeParameterName?: string;
  parameterTypeHints?: Array<{ name: string; dataType: string }>;
}

export function buildParameterAdditionPayload(
  parameterNames: string[],
  options: {
    categories?: string[];
    bindingKind?: 'type' | 'instance';
    targetObjectTypes?: string[];
    objectTypeParameterName?: string;
    parameterTypeHints?: Array<{ name: string; dataType: string }>;
  } = {}
): ParameterAdditionPayload {
  const sharedParameterState = useSharedParameterStore.getState();
  const payload: ParameterAdditionPayload = {
    parameterNames,
  };

  if (options.categories && options.categories.length > 0) {
    payload.categories = options.categories;
  }

  if (options.bindingKind) {
    payload.bindingKind = options.bindingKind;
  }

  if (options.targetObjectTypes && options.targetObjectTypes.length > 0) {
    payload.targetObjectTypes = options.targetObjectTypes;
  }

  if (options.objectTypeParameterName?.trim()) {
    payload.objectTypeParameterName = options.objectTypeParameterName.trim();
  }

  if (options.parameterTypeHints && options.parameterTypeHints.length > 0) {
    payload.parameterTypeHints = options.parameterTypeHints;
  }

  if (sharedParameterState.useDefaultFile) {
    payload.sharedParameterFilePath = sharedParameterState.filePath || 'PipeEX_SharedParameters.txt';
    payload.sharedParameterFileContent = DEFAULT_SHARED_PARAMETERS;
    return payload;
  }

  if (typeof sharedParameterState.fileContent === 'string' && sharedParameterState.fileContent.trim() !== '') {
    payload.sharedParameterFilePath = sharedParameterState.filePath || undefined;
    payload.sharedParameterFileContent = sharedParameterState.fileContent;
  }

  return payload;
}
